module.exports = __webpack_public_path__ + "img/03.b92ba296.png";